import { useContext } from "react";
import { Popover, Button } from "antd";
import { UserOutlined, LogoutOutlined, MenuUnfoldOutlined, MenuFoldOutlined, DownOutlined } from '@ant-design/icons';
import { AppContext } from "../../utils/AppContext";
import history from 'utils/history';
import { 
    HeaderContainer,
    LogoContainer,
    LogoImgContent,
    LogoTitle,
    LogoutButtonContainer
} from "./styled";
import SmartVRLogo from "../../assets/img/smartvr-logo.png"

const Header = () => {
    const { setUserInfo, showMenu, setShowMenu } = useContext(AppContext);
    const name = JSON.parse(localStorage.getItem("session")).name;
    
    const signout = () => {
        setUserInfo({});
        localStorage.removeItem("session")
        history.push('/login')
    }
    const content = (
        <LogoutButtonContainer>
            <Button icon={<LogoutOutlined />} style={{}} onClick={()=>signout()} >
                Sign Out
            </Button>
        </LogoutButtonContainer>
    );

    // TODO: white label header bar here
    return (
        <HeaderContainer>
            <LogoContainer>
                <Button 
                    type="link" 
                    icon={!showMenu ? <MenuFoldOutlined size={20} /> : <MenuUnfoldOutlined size={20} />} 
                    onClick={() => setShowMenu(!showMenu)}
                    style={{color: "white", fontSize: "24px"}}>
                        
                    </Button>
                <LogoImgContent src={SmartVRLogo} />
            </LogoContainer>
            <Popover placement="bottomRight" content={content} trigger="click">
                <Button type="link" icon={<UserOutlined />} style={{marginRight: "8px", color: "white"}}>{name} <DownOutlined /></Button>
            </Popover>
        </HeaderContainer>
    );
};

export default Header;